(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["why-meriavo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('IntersectionObserver' in window)) return;
    const instances = new Map();
    const cooldowns = new Map();
    const duration = 1500;
    const cooldown = 120000;

    function mount(section) {
      if (instances.has(section)) return;
      const buttons = [...section.querySelectorAll('.feature-grid > .feature')];
      if (buttons.length !== 4) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const key = 'meriavo:why-sequence:' + section.dataset.whySequence;
      const visible = new Set();
      let wasAllVisible = false;
      let settleTimer;
      let finishTimer;
      let observer;
      let headerInset;

      function stop() {
        clearTimeout(settleTimer);
        clearTimeout(finishTimer);
        section.removeAttribute('data-why-playing');
      }

      function nextAllowed() {
        let saved = cooldowns.get(key) || 0;
        try { saved = Math.max(saved, Number(sessionStorage.getItem(key)) || 0); } catch (_) {}
        return Number.isFinite(saved) && saved <= Date.now() + duration + cooldown ? saved : 0;
      }

      function play() {
        if (document.hidden || motion.matches || !wasAllVisible || Date.now() < nextAllowed()) return;
        const next = Date.now() + duration + cooldown;
        cooldowns.set(key, next);
        try { sessionStorage.setItem(key, String(next)); } catch (_) {}
        section.setAttribute('data-why-playing', '');
        finishTimer = setTimeout(stop, duration);
      }

      function observe() {
        const header = document.querySelector('.meriavo-header-stack');
        const inset = Math.ceil(header ? header.getBoundingClientRect().height : 0) + 12;
        if (observer && inset === headerInset) return;
        headerInset = inset;
        if (observer) observer.disconnect();
        visible.clear();
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .98) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          const allVisible = visible.size === buttons.length;
          if (allVisible && !wasAllVisible) {
            settleTimer = setTimeout(play, 180);
          } else if (!allVisible) stop();
          wasAllVisible = allVisible;
        }, { threshold: [0, .98, 1], rootMargin: '-' + inset + 'px 0px -24px 0px' });
        buttons.forEach(button => observer.observe(button));
      }

      function onVisibility() { if (document.hidden) stop(); }
      function onMotion() { if (motion.matches) stop(); }
      function dispose() {
        stop();
        observer.disconnect();
        window.removeEventListener('resize', observe);
        window.removeEventListener('pagehide', stop);
        document.removeEventListener('visibilitychange', onVisibility);
        motion.removeEventListener('change', onMotion);
        instances.delete(section);
      }
      instances.set(section, dispose);
      observe();
      window.addEventListener('resize', observe, { passive: true });
      window.addEventListener('pagehide', stop);
      document.addEventListener('visibilitychange', onVisibility);
      motion.addEventListener('change', onMotion);
    }

    function mountWithin(root) {
      if (root.matches && root.matches('[data-why-sequence]')) mount(root);
      root.querySelectorAll('[data-why-sequence]').forEach(mount);
    }
    mountWithin(document);
    document.addEventListener('shopify:section:load', event => mountWithin(event.target));
    document.addEventListener('shopify:section:unload', event => {
      instances.forEach((dispose, section) => {
        if (event.target === section || event.target.contains(section)) dispose();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
